import { render } from "./CompletedActions.vue?vue&type=template&id=3d690a5f&ts=true"
import script from "./CompletedActions.vue?vue&type=script&lang=ts"
export * from "./CompletedActions.vue?vue&type=script&lang=ts"

import "./CompletedActions.vue?vue&type=style&index=0&id=3d690a5f&lang=scss"

import exportComponent from "/home/issa/hcpet/hcpet-kasse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__